import React from 'react';
import { Helmet } from 'react-helmet-async';
import Footer from '../components/Footer';

const KVKK = () => {
  return (
    <>
      <Helmet>
        <title>KVKK - SigortamOlsun Sigorta Aracılık Hiz. Ltd. Şti.</title>
        <meta name="description" content="SigortamOlsun KVKK Aydınlatma Metni" />
      </Helmet>

      <div className="min-h-screen bg-gradient-to-br from-blue-50 to-purple-50">
        <div className="container mx-auto px-4 py-12">
          <div className="max-w-4xl mx-auto bg-white rounded-lg shadow-lg p-8">
            <h1 className="text-3xl font-bold text-gray-800 mb-6">
              SİGORTAMOLSUN SİGORTA ARACILIK HİZMETLERİ LTD. ŞTİ. KİŞİSEL VERİLERİN İŞLENMESİNE İLİŞKİN AYDINLATMA METNİ
            </h1>

            <div className="prose prose-blue max-w-none">
              <div className="bg-gray-50 p-6 rounded-lg mb-8">
                <p className="text-gray-600">
                  İşbu Aydınlatma Metni, 6698 sayılı Kişisel Verilerin Korunması Kanunu ("KVKK") uyarınca, veri sorumlusu sıfatıyla hareket eden SİGORTAMOLSUN SİGORTA ARACILIK HİZMETLERİ LTD. ŞTİ. ("Şirket") tarafından, dijital platformlarımız üzerinden yürütülen tüm faaliyetler kapsamında toplanan kişisel verilerin işlenmesine yönelik ilgili kişilerin aydınlatılması amacıyla hazırlanmıştır.
                </p>
              </div>

              <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">
                Kişisel Verilerin İşlenme Amacı
              </h2>
              <p className="text-gray-600 mb-4">
                Şirketimiz tarafından, işbu Aydınlatma Metni kapsamında belirtilen yöntemlerle toplanan kişisel verileriniz (isim, soyisim, T.C. kimlik numarası, iletişim bilgileri ve e-posta adresi), KVKK'nın 5. maddesinde belirtilen hükümlere uygun olarak aşağıdaki amaçlar doğrultusunda işlenmektedir:
              </p>
              <ul className="list-disc pl-6 text-gray-600 space-y-2">
                <li>Müşteri deneyiminin iyileştirilmesi ve hizmet kalitesinin artırılmasına yönelik çalışmaların yürütülmesi</li>
                <li>Şirketimizin dijital platformları üzerinden sunulan hizmetlerin geliştirilmesi ve müşteri memnuniyetinin sağlanması</li>
                <li>Kampanya, promosyon ve ödül süreçlerinin yönetimi ve organizasyonu</li>
                <li>Tarafınızla iletişime geçilmesi gereken durumlarda gerekli bildirimlerin yapılması</li>
              </ul>

              <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">
                Kişisel Verilerin Aktarılması
              </h2>
              <p className="text-gray-600 mb-4">
                Toplanan kişisel verileriniz, açık rızanız olmaksızın üçüncü kişilerle paylaşılmayacaktır. Ancak yasal yükümlülüklerimiz kapsamında yetkili kamu kurum ve kuruluşlarıyla paylaşılması gerektiği hallerde, ilgili mevzuat çerçevesinde aktarım yapılabilecektir.
              </p>

              <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">
                Kişisel Veri Toplama Yöntemi ve Hukuki Sebep
              </h2>
              <p className="text-gray-600 mb-4">
                Kişisel verileriniz, elektronik ortamda web sitemiz, mobil uygulamamız ve diğer dijital kanallarımız üzerinden toplanmaktadır.
              </p>
              <p className="text-gray-600 mb-4">
                Verilerinizin işlenmesindeki hukuki sebepler, KVKK'nın 5. maddesi kapsamında:
              </p>
              <ul className="list-disc pl-6 text-gray-600 space-y-2">
                <li>Bir sözleşmenin kurulması veya ifası için gerekli olması</li>
                <li>İlgili kişinin kendisi tarafından alenileştirilmiş olması</li>
                <li>Şirketimizin meşru menfaatleri için zorunlu olması</li>
              </ul>

              <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">
                KVKK Kapsamındaki Haklarınız
              </h2>
              <p className="text-gray-600 mb-4">
                KVKK'nın 11. maddesi uyarınca kişisel veri sahipleri olarak aşağıdaki haklara sahipsiniz:
              </p>
              <ul className="list-disc pl-6 text-gray-600 space-y-2">
                <li>Kişisel verilerinizin işlenip işlenmediğini öğrenme</li>
                <li>Kişisel verileriniz işlenmişse buna ilişkin bilgi talep etme</li>
                <li>Kişisel verilerinizin işlenme amacını ve bunların amacına uygun kullanılıp kullanılmadığını öğrenme</li>
                <li>Yurt içinde veya yurt dışında kişisel verilerinizin aktarıldığı üçüncü kişileri bilme</li>
                <li>Kişisel verilerinizin eksik veya yanlış işlenmiş olması hâlinde bunların düzeltilmesini isteme</li>
                <li>KVKK ve ilgili mevzuat hükümlerine uygun olarak işlenmiş olmasına rağmen, işlenmesini gerektiren sebeplerin ortadan kalkması hâlinde kişisel verilerinizin silinmesini veya yok edilmesini isteme</li>
                <li>İşlenen verilerin münhasıran otomatik sistemler vasıtasıyla analiz edilmesi suretiyle aleyhinize bir sonucun ortaya çıkmasına itiraz etme</li>
                <li>Kişisel verilerinizin kanuna aykırı olarak işlenmesi sebebiyle zarara uğramanız hâlinde zararın giderilmesini talep etme</li>
              </ul>

              <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">
                Başvuru Yöntemleri
              </h2>
              <p className="text-gray-600 mb-4">
                Yukarıda belirtilen haklarınızı kullanmak için:
              </p>
              <div className="bg-gray-50 p-6 rounded-lg">
                <p className="text-gray-700 mb-4">Web sitemizde yer alan Kişisel Veri Sahibi Başvuru Formunu doldurarak:</p>
                <ul className="list-disc pl-6 text-gray-700 space-y-2">
                  <li>Şirketimize şahsen başvurabilir</li>
                  <li>Noter kanalıyla gönderebilir</li>
                  <li>Güvenli elektronik imza ile imzalayarak KEP adresimize iletebilir</li>
                  <li>Sistemimizde kayıtlı e-posta adresiniz üzerinden başvurabilirsiniz</li>
                </ul>
                <p className="text-gray-700 mt-4">
                  Başvurunuz en kısa sürede ve en geç 30 gün içerisinde ücretsiz olarak sonuçlandırılacaktır. İşlemin ayrıca bir maliyet gerektirmesi halinde, Kişisel Verileri Koruma Kurulu tarafından belirlenen tarifeye göre ücret talep edilebilecektir.
                </p>
              </div>

              <div className="bg-blue-50 p-6 rounded-lg mt-8">
                <h2 className="text-xl font-semibold text-blue-800 mb-4">
                  İLETİŞİM BİLGİLERİ
                </h2>
                <ul className="text-gray-700 space-y-2">
                  <li>E-posta: info@sigortamolsun.com</li>
                  <li>KEP Adresi: sigortamolsun@hs01.kep.tr</li>
                  <li>Web: www.sigortamolsun.com</li>
                  <li>Mersis No: 0770099257700001</li>
                  <li>Adres: Ünsal, 5088. Sk. No: 22, 07080 Kepez/Antalya</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </>
  );
};

export default KVKK;